module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keep-alive', [_c('v-header', {
    attrs: {
      "dark": _vm.dark,
      "plan": _vm.plan,
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    on: {
      "isdark": _vm.getDark
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('v-foot', {
    attrs: {
      "plan": _vm.plan,
      "product": _vm.product,
      "caselist": _vm.caselist,
      "BackUp": _vm.BackUp,
      "CopyRight": _vm.CopyRight,
      "weixinImg": _vm.weixinImg,
      "appImg": _vm.appImg
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f42abbc8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 70
// module chunks = 15